/**
 * Thrown when the v2 database cannot be opened within the bounded window.
 *
 * Its own import-free module: `errors.ts` classifies it and is imported by the
 * mic, connectivity and chunk paths, so declaring it beside `ensureOpen` would
 * drag `dbV2` into all of their bundles.
 */
export class PersistenceUnavailableError extends Error {
  constructor(message?: string) {
    super(message);
    // Named like its write-fence siblings: every triage log and the store-health
    // classifier read `name`, and an unnamed subclass reports as plain `Error`.
    this.name = 'PersistenceUnavailableError';
  }
}
